import FunnelDiagram from "../../components/statistics/funnel/funnel";
import { Header } from "../../components/header";
import { AppMainMenu } from "../../components/menu";
import PanelBody from "../../components/panel/body";
import PanelSubHeading from "../../components/panel/subHeading";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "sonner";
import { FilterIcon } from "../../icons/filter";
import { RootState } from "../../state/reducer";
import { closeModal, openModal } from "../../state/modalSlice";
import SelectFunnelModal from "../../modals/stats/funnelSelect";
import UserListTable from "../../components/users/userListTable";
import FunnelTableWrapper from "../../components/statistics/tables/funnelTable";
import PanelPage from "../../components/panel/panelPage";
import { backend, statsBackend } from "../../services";
import { FunnelTableData, FunnelTableRow, FunnelTemplate, ValueCell } from "../../types";
import {
  generateCellsFromEventData,
} from "../../utils";
import { hireFunnelTemplate, practiceFunnelTemplate, saleFunnelTemplate, StatsFilters } from "../../forms/filters/stats";
import SelectFunnelTemplateModal from "../../modals/stats/templateSelect";

const formatNames = {
  funnel: "Воронка",
  column: "Столбцы",
  round: "Кург"
};


async function generateTableData (filters: StatsFilters): Promise<FunnelTableData> {
   const {groups} = await backend.getAllGroups();
   const data: FunnelTableRow[] = [];
   for (let i = 0; i < groups.length; i++) {
    const groupfilters = {...filters, user_ids: [], group_ids: [groups[i].id]};
    const row = await statsBackend.getFunnelData(groupfilters);
    data.push({
      heading: groups[i].name,
      values: generateCellsFromEventData(row.data)
   })
   }
   return {data}
}

const SalesFunnelPage = () => {
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const [values, setValues] = useState<ValueCell[]>([]);
  const [tableData, setTableData] = useState<FunnelTableData>({data: []});

  useEffect(() => {
    statsBackend.getFunnelData(State.statsFilters).then((res) => {
      setValues(generateCellsFromEventData(res.data))
    }).catch(e => {
      console.log("Error:", e)
    })
    generateTableData(State.statsFilters).then((res) => {
      console.log("Generated:", res)
      setTableData(res)
    })
  }, [State.statsFilters]);

  const handleOpenFilters = () => {
    dispatch(
      openModal({
        component: SelectFunnelModal,
        context: {
          onSave: () => {
            console.log("Save");
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  const selectFormat = () => {
    dispatch(
      openModal({
        component: SelectFunnelTemplateModal,
        context: {
          onSave: () => {
            console.log("Save");
          },
          closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
        },
      })
    );
  };

  console.log("Fetched for table:", tableData.data)

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="flex between w100 panelColumnFull">
          <div className="columnCenter panelColumnFull">
            <div
              className="panel eventListPanel"
              style={{
                marginBottom: 16,
              }}
            >
              <div className="columnCenter">
                <div className="flex between w100">
                  <PanelSubHeading text="Воронка" />
                  <div className="flex gap24 vertCenter">
                    <div className="panelBtnContainer">
                      <div
                        className="btn panelActionBtn"
                        onClick={handleOpenFilters}
                      >
                        <span style={{ display: "flex", whiteSpace: "nowrap" }}>
                          <span>
                            {(() => {
                              const templateData = State.statsFilters.event_ids;
                              switch (templateData) {
                                case saleFunnelTemplate:
                                  return "Шаблон: Воронка продаж";
                                  break;
                                case practiceFunnelTemplate:
                                  return "Шаблон: Воронка по практикам";
                                  break;
                                case hireFunnelTemplate:
                                  return "Шаблон: Воронка найма";
                                  break;
                                default:
                                  return "Шаблон: Пользовательский"
                              }
                            })()}
                          </span>
                        </span>
                      </div>
                    </div>
                    {/* <div className="panelBtnContainer">
                        <div className="btn panelActionBtn">
                          <span
                            style={{ display: "flex", whiteSpace: "nowrap" }}
                          >
                            <span>Последние 30 дней</span>
                          </span>
                        </div>
                      </div> */}
                    <div className="panelBtnContainer">
                      <div
                        className="btn panelActionBtn"
                        onClick={selectFormat}
                      >
                        <span style={{ display: "flex", whiteSpace: "nowrap" }}>
                          <span>Формат:</span>
                          <span>{formatNames[State.statsTemplateConfig.template]}</span>
                        </span>
                      </div>
                    </div>
                    <div className="btn filterBtn" onClick={handleOpenFilters}>
                      <FilterIcon width={20} height={20} />
                    </div>
                  </div>
                </div>
                <FunnelDiagram
                  category={"sales"}
                  config={State.statsTemplateConfig}
                  values={values}
                />
              </div>
            </div>
            <div className="panel eventListPanel">
              <div className="flex between w100">
                <PanelSubHeading text="Рейтинг офисов" />
              </div>
              <FunnelTableWrapper  data={tableData.data} />
            </div>
          </div>
        </div>
      </div>
    </PanelPage>
  );
};

export default SalesFunnelPage;
